import React from 'react';
import { Link } from 'react-router-dom';
import ProductsHero from '../components/ProductsHero/ProductsHero';
import { PRODUCT_MODULES } from '../../seo/productModules';
import { getPublicPageSeo } from '../../seo/publicPages';
import './Products.css';

const Products = () => (
  <div className="products-page">
    <ProductsHero title="Products">
      <p className="text-muted">
        flowdo is modular business software. Pick Tasks, Snap Bill, Documents, Projects, Credentials
        Vault, or Discussion Forum — pay only for what you use. Every module starts free.
      </p>
    </ProductsHero>
    <section className="products-hub">
      <div className="container">
        <div className="features-grid">
          {PRODUCT_MODULES.map((module) => {
            const seo = getPublicPageSeo(module.to);
            return (
              <Link key={module.to} to={module.to} className="feature-card products-hub-card">
                <span className="products-hub-icon" aria-hidden="true">
                  <i className={module.iconClass} />
                </span>
                <h2>{module.title}</h2>
                <p>{seo?.heading || module.text}</p>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  </div>
);

export default Products;
